import {
  HostNamesDefaults,
  ORG_ID_TO_HOSTNAMES
} from "lib/constants/organizations";
import { User } from "@madhive/mad-sdk";
import { NODE_ENV } from "lib/viteEnvConfig";

export const hostname = window.location.hostname;

export const isLocalhost = Boolean(
  hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export const isTesthost = Boolean(
  NODE_ENV === "test" ||
    hostname.includes("-ue.a.run.app") ||
    hostname.includes("madhive-testing")
);

export const isSandboxHost = Boolean(
  hostname.match(/pr-[\d]+---smithers-[\w]+-[\w]+\.a\.run\.app/)
);

/**
 * Matches Smithers' Firebase Hosting default and preview-channel URLs, e.g.
 *   smithers-mad-hack.web.app                    (default channel)
 *   smithers-mad-hack--internal-<hash>.web.app   (preview channel)
 *
 * Preview-channel hashes are ephemeral (channels expire in 7-30 days), so we
 * match the structural pattern rather than any specific hash. This allows logins
 * from the maintenance "internal" preview channel that holds the live Smithers
 * build while the maintenance page is served on the primary domain.
 */
export const isFirebaseHostingHost = /^smithers-[\w-]+\.web\.app$/.test(
  hostname
);

const isProperHostname = (user: User) => {
  const validHostnames = ORG_ID_TO_HOSTNAMES[user.primaryOrganizationId];
  return validHostnames.includes(hostname);
};

export function ensureUserCanLoginFromThisAddress(user: User) {
  if (
    /^preview\..*@madhive\.com$/.test(user.email) &&
    !isSandboxHost &&
    !isLocalhost
  ) {
    return false;
  }

  if (isLocalhost || isTesthost || isSandboxHost || isFirebaseHostingHost) {
    return true;
  }

  if ((HostNamesDefaults as string[]).includes(hostname)) {
    return true;
  }

  return isProperHostname(user);
}
